import Button from 'flarum/common/components/Button';
import Form from 'flarum/common/components/Form';
import FormModal from 'flarum/common/components/FormModal';
import Stream from 'flarum/common/utils/Stream';
export default class UserMoneyModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.money = Stream(this.attrs.user.data.attributes['money'] || 0.0);
  }
  className() {
    return 'UserMoneyModal Modal--small';
  }
  title() {
    return app.translator.trans('antoinefr-money.forum.modal.title', {
      user: this.attrs.user
    });
  }
  content() {
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('antoinefr-money.forum.modal.current'), " ", moneyName.replace('[money]', this.attrs.user.data.attributes['money'])), m("input", {
      required: true,
      className: "FormControl",
      type: "number",
      step: "any",
      bidi: this.money
    })), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('antoinefr-money.forum.modal.submit_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.attrs.user.save({
      money: this.money()
    }, {
      errorHandler: this.onerror.bind(this)
    }).then(this.hide.bind(this)).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('antoinefr-money', 'forum/components/UserMoneyModal', UserMoneyModal);